// src/modules/app-views/invoices/pages/Init/modals/EmitInvoiceNfceModal/Step1.jsx
// *******************************************************************************
// EMIT INVOICE STEP - CPF Input for NFC-e
// *******************************************************************************
// Allows user to optionally enter a CPF before emitting the NFC-e invoice.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleCpf from 'components/SimpleComponents/SimpleCpf';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const EmitInvoiceStepContent = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="emit-invoice-modal-content" style={{ paddingTop: 8 }}>
      <SimpleCpf
        name="cpf"
        label={translateX('cpf')}
        placeholder={translateX('cpf_optional')}
      />
    </div>
  );
};

// *******************************************************************************
// STEP CONFIGURATION FACTORY
// *******************************************************************************
const createEmitInvoiceStep = () => ({
  stepTitle: 'emit_nfce',
  stepTooltip: 'emit_nfce_tooltip',
  content: () => <EmitInvoiceStepContent />,
  validationFields: [],
  onEnter: () => {
    // Focus on CPF input field when modal opens
    setTimeout(() => {
      const input = document.querySelector('.emit-invoice-modal-content input');
      if (input) {
        input.focus();
      }
    }, 150);
  },
});

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default createEmitInvoiceStep;
